import React, { useEffect } from "react";

import { PropTypes } from "prop-types";

import ErrorIcon from "@/icons/ErrorIcon";
import {
  activityErrorMessageContainerCss,
  activityErrorMessageCss,
  messageContainerCss,
  iconCss,
} from "./ActivityErrorMessage.style";

const propTypes = {
  message: PropTypes.string,
  ref: PropTypes.func, // PropTypes.ref is not part of PropTypes https://stackoverflow.com/a/51127130
};

const ActivityErrorMessage = React.forwardRef(({ message }, ref) => {
  useEffect(() => {
    ref.current.scrollIntoView({
      behavior: "auto",
      block: "nearest",
    });
  }, []);

  return (
    <div role="alert" css={activityErrorMessageContainerCss} ref={ref}>
      <div css={activityErrorMessageCss}>
        <span>
          <ErrorIcon css={iconCss} aria-hidden="true" />
        </span>
        <span css={messageContainerCss}>{message}</span>
      </div>
    </div>
  );
});

ActivityErrorMessage.propTypes = propTypes;
export default ActivityErrorMessage;
